import {
  CloseButton,
  ListContext,
  ListContextValue,
  Stack,
  Typography,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { SubmitButton } from "components";
import { Class as ClassModel } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { ClassCreateContext, ClassCreateContextValue } from "./ClassCreatePage";

export const ClassPageHeader = (props: {
  handle: string;
  class: ClassModel;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
  closeOnSave?: boolean;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listContext = useContext<ListContextValue>(ListContext);
  const classCreateContext = useContext<ClassCreateContextValue>(ClassCreateContext);

  const save = (classTemp: ClassModel) => {
    props.setValidationErrors({});

    ApiService.classes
      .saveCreate(classTemp)
      .then((response) => {
        const id = response;
        if (props.closeOnSave) navigate(`../`);
        // TODO: else navigate(`../${providerPageRoute.getPath({ id: id, crudMode: "view" })}`);

        listContext.loadList?.();
        classCreateContext?.onCreate?.(id);
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.response);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton confirm={props.unsavedChanges} />
        <SubmitButton onClick={() => save(props.class)} disabled={props.class.id > 0 && !props.unsavedChanges} />
      </Stack>
    </Stack>
  );
};
